/* eslint-disable @typescript-eslint/init-declarations */
import { updateLoggerContext } from '@doxyme/analytics';
import { benchmarkMethod } from './benchmarkMethod';

type CPUPerformance = {
  mean: number;
  standardDeviation: number;
};

let CPUData: CPUPerformance | undefined;

export const getCPUData = async (): Promise<CPUPerformance> => {
  if (CPUData !== undefined) {
    return CPUData;
  }

  // eslint-disable-next-line require-atomic-updates
  CPUData = await runCPUBenchmark();
  updateLoggerContext({ cpuScore: CPUData });
  return CPUData;
};

async function runCPUBenchmark(): Promise<CPUPerformance> {
  return new Promise((resolve) => {
    const benchmarkDuration = 1000; // Run for 1 seconds
    const samples: number[] = [];
    const sampleInterval = 100; // Take a sample every 100ms
    benchmarkMethod();

    const startTime = performance.now();
    let iterations = 0;
    let lastSampleTime = startTime;

    const runIteration = (): void => {
      benchmarkMethod();
      iterations++;

      const currentTime = performance.now();
      if (currentTime - lastSampleTime >= sampleInterval) {
        const elapsedTime = (currentTime - lastSampleTime) / 1000; // Convert to seconds
        const iterationsPerSecond = iterations / elapsedTime;
        samples.push(iterationsPerSecond);
        lastSampleTime = currentTime;
        iterations = 0;
      }

      if (currentTime - startTime < benchmarkDuration) {
        setTimeout(runIteration, 0);
      } else {
        const mean =
          samples.reduce((sum, value) => sum + value, 0) / samples.length;
        const variance =
          samples.reduce((sum, value) => sum + Math.pow(value - mean, 2), 0) /
          samples.length;
        const standardDeviation = Math.sqrt(variance);

        resolve({ mean, standardDeviation });
      }
    };
    runIteration();
  });
}
